<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:max-width="modalOptions.largura"
			:min-height="modalOptions.altura"
			:is-confirmar-visivel="isConfirmarVisivel"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmarAditar"
			nome-botao-confirmar="Aditar"
			:is-confirmar-desabilitado="isConfirmarDesabilitado"
			:tamanho="modalOptions"
			@close="fecharModal"
		>
			<template #body>
				<div class="my-1" :class="{ ajustar_altura_do_modal_com_historico: !$vuetify.breakpoint.mobile }">
					<painel-com-tabs-sem-rotas :tabs="tabs" @tab-atual="selecionarTabelaAtual">
						<template #aditar>
							<aditar-item :item-selecionado="itemSelecionado"></aditar-item>
						</template>
						<template #historico>
							<div class="mt-2">
								<historico-aditamento-item></historico-aditamento-item>
							</div>
						</template>
					</painel-com-tabs-sem-rotas>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { TabSemRotaUtils } from '@/core/utils'
import AditarItem from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/aditamento/aditar/AditarItem.vue'
import HistoricoAditamentoItem from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/aditamento/historico/HistoricoAditamentoItem.vue'
import { actionTypes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'modal-aditar-item',
	components: { AditarItem, HistoricoAditamentoItem },
	mixins: [validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
		itemSelecionado: {
			type: Object,
			required: true,
			default: null,
		},
	},
	data() {
		return {
			tabs: [
				new TabSemRotaUtils(1, 'Aditamento', 'aditar', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico'),
			],
			tituloModal: 'Aditar Item',
			modalOptions: {
				largura: '1076',
				altura: '1600',
			},
			isConfirmarVisivel: this.temPermissaoEdicao,
			isFormValid: true,
		}
	},
	computed: {
		isConfirmarDesabilitado() {
			return !this.isFormValid
		},
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
			this.$emit('carregar-listagem')
		},
		selecionarTabelaAtual(escondeConfirmar) {
			if (this.temPermissaoEdicao) this.isConfirmarVisivel = !escondeConfirmar
			else this.isConfirmarVisivel = false
		},
		async confirmarAditar() {
			if (this.$refs.form.validate()) {
				await this.$store.dispatch(actionTypes.ITEM_ATA.ADITAMENTO.ADITAR.INSERIR_PERCENTUAL)
				this.fecharModal()
				this.mostrarNotificacaoSucessoDefault()
			}
		},
	},
}
</script>

<style lang="stylus" scoped>
.ajustar_modal_aba_historico {
	height: 500px;
}
</style>
